import { useState } from 'react';
import type { CSSProperties } from 'react';
import type { Tracker } from '@fleet/shared';
import { fmtDate } from '@fleet/shared';
import { TrackerTegel } from '../../components/ui/TrackerTegel';

const chipStyle = (on: boolean): CSSProperties => ({
  background: on ? '#2A6085' : '#FFFFFF',
  color: on ? '#FFFFFF' : '#2A6085',
  border: `1px solid ${on ? '#2A6085' : '#C9BBA8'}`,
  borderRadius: 2,
  padding: '5px 12px',
  fontSize: 12,
  fontWeight: 700,
  cursor: 'pointer',
  fontFamily: 'Roboto, sans-serif',
});

/**
 * A row of month-on-month tiles.
 *
 * Used once per cost section, so the figures sit above the charts that work them
 * out rather than all eight in one bank at the top with no clue which chart each
 * belongs to.
 *
 * The per-car switch is per row on purpose: it is a way of looking at the tiles
 * in front of you, not a page-wide mode. Tiles that cannot be divided by a car
 * count — a price per litre — simply ignore it.
 */
export function TrackerRow({
  trackers,
  laatsteTransactie,
  perAutoMogelijk = true,
}: {
  trackers: Tracker[];
  /** Shown as a freshness note; omit on the second row to avoid repeating it. */
  laatsteTransactie?: string | null;
  perAutoMogelijk?: boolean;
}) {
  const [perAuto, setPerAuto] = useState(false);
  if (!trackers.length) return null;

  const kop = laatsteTransactie || perAutoMogelijk;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {kop && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            flexWrap: 'wrap',
          }}
        >
          <span style={{ fontSize: 12, color: '#999999' }}>
            {laatsteTransactie ? `tankpasdata t/m ${fmtDate(laatsteTransactie)}` : ''}
          </span>
          {perAutoMogelijk && (
            <div style={{ display: 'flex', gap: 6 }}>
              <button type="button" style={chipStyle(!perAuto)} onClick={() => setPerAuto(false)}>
                Totaal
              </button>
              <button type="button" style={chipStyle(perAuto)} onClick={() => setPerAuto(true)}>
                Per auto
              </button>
            </div>
          )}
        </div>
      )}

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(215px, 1fr))',
          gap: 16,
        }}
      >
        {trackers.map((t) => (
          <TrackerTegel key={t.key} tracker={t} perAuto={perAuto} />
        ))}
      </div>
    </div>
  );
}
